<template>
  <div class="ai-plan-editor">
    <template v-if="!plans.length">
      <CriteriaEditor :value="criteria" :definitions="definitions" @input="$emit('input',$event)"/>
      <el-button size="small" @click="startPlans">添加另一组选品方案</el-button>
      <p class="plan-hint">如需同时推荐普通配方和特配，可分别配置两组条件，产品满足其中一组即可。</p>
    </template>
    <template v-else>
      <el-alert title="方案之间满足任一组即可；每组内的必要条件必须全部满足。宝宝月龄、产品启用状态和公共限制始终生效。" type="info" :closable="false" show-icon/>
      <p class="plan-hint">符合条件的优先星标先展示，再按方案顺序、标签和组内数值排序；同一产品只展示一次。</p>
      <el-collapse class="common-conditions">
        <el-collapse-item :title="hasCommon?'公共条件（已设置，所有方案都必须满足）':'公共条件（可选，所有方案都必须满足）'" name="common">
          <CriteriaEditor :value="commonCriteria" :definitions="definitions" category-optional @input="setCommon"/>
        </el-collapse-item>
      </el-collapse>
      <section v-for="(plan,i) in plans" :key="i" class="plan-card">
        <div class="plan-heading">
          <b>方案 {{i+1}}</b>
          <el-input :value="plan.name" size="small" maxlength="80" placeholder="方案名称，如普通高乳清方案" @input="setPlan(i,{name:$event})"/>
          <el-button type="text" :disabled="i===0" @click="movePlan(i,-1)">上移</el-button>
          <el-button type="text" :disabled="i===plans.length-1" @click="movePlan(i,1)">下移</el-button>
          <el-button type="text" :disabled="plans.length===1" @click="removePlan(i)">移除方案</el-button>
        </div>
        <CriteriaEditor :value="plan.criteria" :definitions="definitions" @input="setPlan(i,{criteria:$event})"/>
      </section>
      <el-button size="small" :disabled="plans.length>=8" @click="addPlan">添加选品方案</el-button>
      <span class="plan-hint"> 最多 8 组；无完整匹配时，兜底仍须满足对应方案的全部必要条件。</span>
    </template>
  </div>
</template>
<script>
import CriteriaEditor from './ai-criteria-editor';
import { clone, emptyCriteria, normalizeCriteria } from './ai-api';
export default {
  components: { CriteriaEditor },
  props: { value: { type: Object, required: true }, definitions: { type: Array, default: () => [] } },
  computed: {
    criteria() { return normalizeCriteria(this.value); },
    plans() { return this.criteria.plans || []; },
    commonCriteria() { const c = clone(this.criteria); delete c.plans; return c; },
    hasCommon() { const c = this.commonCriteria; return !!c.category || ['any_tags', 'must_tags', 'exclude_tags', 'requirements', 'sort'].some(k => c[k].length > 0); }
  },
  methods: {
    emitPlans(plans) { this.$emit('input', { ...this.criteria, plans }); },
    startPlans() { const first = clone(this.criteria); delete first.plans; this.$emit('input', { ...emptyCriteria(), plans: [{ name: first.category ? first.category + '方案' : '方案 1', criteria: first }, { name: '方案 2', criteria: emptyCriteria() }] }); },
    addPlan() { this.emitPlans([...this.plans, { name: '方案 ' + (this.plans.length + 1), criteria: emptyCriteria() }]); },
    setPlan(i, changes) { const plans = clone(this.plans); plans[i] = { ...plans[i], ...changes }; this.emitPlans(plans); },
    removePlan(i) { const plans = clone(this.plans); plans.splice(i, 1); this.emitPlans(plans); },
    movePlan(i, by) { const plans = clone(this.plans); const plan = plans.splice(i, 1)[0]; plans.splice(i + by, 0, plan); this.emitPlans(plans); },
    setCommon(c) { this.$emit('input', { ...c, plans: clone(this.plans) }); }
  }
};
</script>
<style scoped>
.plan-hint{font-size:12px;color:#71808f;line-height:1.7}.plan-card{border:1px solid #dce5ec;border-radius:4px;margin:18px 0;padding:18px;background:#fff}.plan-heading{display:flex;align-items:center;gap:12px;margin-bottom:20px}.plan-heading>b{white-space:nowrap}.plan-heading>.el-input{flex:1;max-width:420px}.plan-heading>.el-button{margin-left:0}.common-conditions{margin:14px 0}.ai-plan-editor>.el-alert{margin-bottom:12px}
</style>
